import {memo} from "react";
import PropTypes from "prop-types";

/**
 * One route to earning tickets.
 *
 * `progress` is optional: repeating goals (transactions, referrals) show a meter
 * toward the next ticket, one-off goals (card linked) have nothing to meter.
 * The slot still reserves the meter's height either way, so the chip below it
 * lands on the same line across a row of cards regardless of which have one.
 */
const EarningCard = ({label, value, unit, earned, progress, nextHint, pendingHint}) => (
    <article className="hp-card">
        <h3 className="hp-label">{label}</h3>

        <div className="hp-card-value">
            <b className="hp-figure">{value}</b>
            {unit && <span>{unit}</span>}
        </div>

        {typeof progress === 'number' ? (
            <div className="hp-meter" role="presentation">
                <div className="hp-meter-fill" style={{width: `${Math.round(progress * 100)}%`}}/>
            </div>
        ) : (
            <div className="hp-meter-placeholder" aria-hidden="true"/>
        )}

        {earned > 0 ? (
            <span className="hp-chip hp-chip-earned">
                <span className="hp-chip-dot" aria-hidden="true"/>
                +{earned} урамшууллын эрх
            </span>
        ) : (
            <span className="hp-chip hp-chip-pending">
                <span className="hp-chip-dot" aria-hidden="true"/>
                Хараахан эрх аваагүй
            </span>
        )}

        <p className="hp-next">{earned > 0 ? nextHint : pendingHint}</p>
    </article>
);

EarningCard.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    unit: PropTypes.string,
    earned: PropTypes.number.isRequired,
    progress: PropTypes.number,
    nextHint: PropTypes.string.isRequired,
    pendingHint: PropTypes.string.isRequired,
};

export default memo(EarningCard);
